module.exports = __webpack_public_path__ + "img/fig2.bcbcb8d6.png";